import { ACTIVATION_FORM_URL } from './intake';

// Approved 12-panel public catalog — exact order is intentional. Wholesale costs are never stored here.
export const products = [
  {
    id: 'mens-essential-hormone-check',
    category: 'mens',
    name: "Men's Essential Hormone Check",
    price: 125,
    tagline: "Focused, lower-cost androgen snapshot",
    bestFor: "Men who want a focused, lower-cost snapshot of key androgen markers or a simple starting point before broader hormone testing.",
    redDropKits: null,
    biomarkers: ["Total Testosterone", "Free Testosterone", "SHBG", "Albumin"],
  },
  {
    id: 'womens-essential-hormone-check',
    category: 'womens',
    name: "Women's Essential Hormone Check",
    price: 125,
    tagline: "Focused, lower-cost sex-hormone snapshot",
    bestFor: "Women who want a focused, lower-cost snapshot of key sex-hormone markers before deciding whether broader hormone testing is needed.",
    redDropKits: null,
    biomarkers: ["Total Testosterone", "Free Testosterone", "SHBG", "Albumin", "Estradiol"],
  },
  {
    id: 'mens-hormone-followup',
    category: 'mens',
    name: "Men's Hormone Follow-Up",
    price: 150,
    tagline: "Focused follow-up for men on hormone therapy",
    bestFor: "Men already being monitored for hormone therapy or hormone optimization who need a focused follow-up between broader assessments.",
    redDropKits: 1,
    biomarkers: ["CBC", "Total Testosterone", "Free Testosterone", "SHBG", "Estradiol"],
  },
  {
    id: 'womens-hormone-followup',
    category: 'womens',
    name: "Women's Hormone Follow-Up",
    price: 150,
    tagline: "Focused follow-up for women on hormone therapy",
    bestFor: "Women already being monitored for hormone therapy, cycle-related hormone changes, or hormone optimization who need a focused follow-up.",
    redDropKits: 1,
    biomarkers: ["Testosterone", "Estradiol", "Progesterone", "LH", "FSH", "DHEA-S"],
  },
  {
    id: 'mens-hormone-baseline',
    category: 'mens',
    name: "Men's Hormone Baseline",
    price: 225,
    tagline: "Broader hormone baseline with thyroid, lipids & PSA",
    bestFor: "Men who want a broader hormone baseline before starting or adjusting a hormone-focused plan, with thyroid, lipid, metabolic and prostate-related markers.",
    redDropKits: 2,
    biomarkers: ["Total Testosterone", "Free Testosterone", "PSA", "Estradiol", "CMP (Albumin, ALP, ALT, AST, BUN, Calcium, Creatinine, Total Bilirubin, Total Protein)", "Lipid Panel", "SHBG", "TSH", "Free T3", "Free T4"],
  },
  {
    id: 'womens-hormone-baseline',
    category: 'womens',
    name: "Women's Hormone Baseline",
    price: 225,
    tagline: "Broader hormone baseline with thyroid, adrenal & reproductive markers",
    bestFor: "Women who want a broader hormone baseline with thyroid, adrenal, metabolic and reproductive hormone markers before starting or adjusting a hormone-focused plan.",
    redDropKits: 2,
    biomarkers: ["CBC", "CMP (Albumin, ALP, ALT, AST, BUN, Calcium, Creatinine, Total Bilirubin, Total Protein)", "Lipid Panel", "TSH", "AM Cortisol", "Testosterone", "Estradiol", "Progesterone", "LH", "FSH", "DHEA-S", "SHBG"],
  },
  {
    id: 'weight-hormone-panel',
    category: 'metabolic',
    name: "Weight + Hormone Panel",
    price: 225,
    tagline: "Weight & body composition with thyroid, cortisol and sex-hormone context",
    bestFor: "Adults focused on weight management, body composition, or metabolic health who also want thyroid, cortisol and sex-hormone context.",
    redDropKits: 2,
    biomarkers: ["HbA1c", "CBC with Differential/Platelets", "Comprehensive Metabolic Panel", "DHEA-S", "Total Testosterone", "Calculated Free Testosterone", "Estradiol", "Progesterone", "Cortisol", "TSH", "Free T3"],
  },
  {
    id: 'mens-comprehensive-baseline',
    category: 'mens',
    name: "Men's Comprehensive Baseline Panel",
    price: 300,
    tagline: "Broad optimization baseline — metabolic, cardio, thyroid, hormones, iron, nutrients",
    bestFor: "Men who want a broad optimization baseline spanning metabolic, cardiovascular, thyroid, hormone, inflammation, iron and nutrient status.",
    redDropKits: 3,
    biomarkers: ["CBC", "CMP", "Lipid Panel", "HbA1c", "Fasting Insulin", "TSH", "Free T4", "Free T3", "Total Testosterone", "Free Testosterone", "SHBG", "Estradiol", "DHEA-S", "PSA", "hs-CRP", "Ferritin", "Iron/TIBC", "Vitamin D", "Vitamin B12", "Folate"],
  },
  {
    id: 'womens-comprehensive-baseline',
    category: 'womens',
    name: "Women's Comprehensive Baseline Panel",
    price: 300,
    tagline: "Broad optimization baseline — metabolic, cardio, thyroid, reproductive hormones, iron, nutrients",
    bestFor: "Women who want a broad optimization baseline spanning metabolic, cardiovascular, thyroid, reproductive hormone, inflammation, iron and nutrient status.",
    redDropKits: 3,
    biomarkers: ["CBC", "CMP", "Lipid Panel", "HbA1c", "Fasting Insulin", "TSH", "Free T4", "Free T3", "Estradiol", "Progesterone", "Total Testosterone", "Free Testosterone", "SHBG", "FSH", "LH", "DHEA-S", "hs-CRP", "Ferritin", "Iron/TIBC", "Vitamin D", "Vitamin B12", "Folate"],
  },
  {
    id: 'metabolic-weight-optimization',
    category: 'metabolic',
    name: "Metabolic + Weight Optimization Panel",
    price: 225,
    tagline: "Deeper metabolic panel — insulin, ApoB, glucose, thyroid, inflammation",
    bestFor: "Adults focused on weight loss, insulin resistance, cardiometabolic risk, or metabolic optimization who want a deeper metabolic panel than a basic weight-loss screen.",
    redDropKits: null,
    biomarkers: ["CBC", "CMP", "Lipid Panel", "ApoB", "HbA1c", "Fasting Glucose", "Fasting Insulin", "TSH", "Free T4", "hs-CRP", "Vitamin D", "Ferritin"],
  },
  {
    id: 'performance-recovery',
    category: 'performance',
    name: "Performance + Recovery Panel",
    price: 300,
    tagline: "Recovery, inflammation, iron, thyroid, hormones, micronutrients, IGF-1",
    bestFor: "Active adults, athletes and performance-focused clients who want a deeper view of recovery, inflammation, iron status, thyroid, hormones, micronutrients and IGF-1.",
    redDropKits: 3,
    biomarkers: ["CBC", "CMP", "Lipid Panel", "HbA1c", "Ferritin", "Iron/TIBC", "hs-CRP", "CK", "TSH", "Free T4", "Total Testosterone", "Free Testosterone", "SHBG", "Vitamin D", "Vitamin B12", "Folate", "Magnesium", "IGF-1"],
  },
  {
    id: 'advanced-therapy-monitoring',
    category: 'monitoring',
    name: "Advanced Therapy Monitoring Panel",
    price: 300,
    tagline: "Longitudinal monitoring for clinician-directed advanced therapy",
    bestFor: "Adults undergoing clinician-directed advanced therapy who need broader longitudinal monitoring of metabolic, hormone, inflammation, prostate and IGF-1 markers.",
    redDropKits: 3,
    biomarkers: ["CBC", "CMP", "Lipid Panel", "HbA1c", "Fasting Glucose", "Total Testosterone", "Free Testosterone", "SHBG", "Estradiol", "PSA", "IGF-1", "hs-CRP", "Ferritin", "Vitamin D"],
  },
];

export const priceLabel = (p) => (p.price == null ? 'Pricing on activation form' : `$${p.price}`);
export const orderLabel = (p, verb = 'Complete Order Form') => (p.price == null ? verb : `${verb} · $${p.price}`);
export const redDropLabel = (p) => (p.redDropKits ? `${p.redDropKits} RedDrop ${p.redDropKits === 1 ? 'Test Kit' : 'Test Kits'}` : null);

export const categories = [
  { id: 'all', label: 'All Panels' },
  { id: 'mens', label: "Men's" },
  { id: 'womens', label: "Women's" },
  { id: 'metabolic', label: 'Metabolic & Weight' },
  { id: 'performance', label: 'Performance' },
  { id: 'monitoring', label: 'Therapy Monitoring' },
];


// 10 CPI Domains — matches integratednycai.com Clinical Performance Index
export const cpiDomains = [
  { code: 'MET', name: 'Metabolic', desc: 'Insulin sensitivity, glucose regulation, cellular energy.' },
  { code: 'HRM', name: 'Hormonal / Neuroendocrine', desc: 'Sex hormones, thyroid, adrenal balance.' },
  { code: 'ENR', name: 'Energy / Mitochondrial', desc: 'Cellular energy production and daytime vitality.' },
  { code: 'SLP', name: 'Sleep / Recovery', desc: 'Restorative sleep and circadian repair.' },
  { code: 'STR', name: 'Stress / Autonomic', desc: 'Autonomic balance, cortisol rhythm, resilience.' },
  { code: 'GUT', name: 'Gut / Microbiome', desc: 'Digestion, absorption, microbial diversity.' },
  { code: 'CVD', name: 'Cardiovascular', desc: 'Lipids, ApoB, vascular health, blood pressure.' },
  { code: 'INF', name: 'Inflammation / Immune', desc: 'Systemic inflammation and immune competence.' },
  { code: 'NEU', name: 'Neurocognitive', desc: 'Focus, mood, memory, brain performance.' },
  { code: 'NTR', name: 'Nutrient / Methylation', desc: 'Micronutrients, methylation, biochemistry.', isHome: true },
];

// Optimization Programs — from integratednycai.com
export const optimizationPrograms = [
  { code: 'PRG.01', title: 'Health Optimization', desc: 'Whole-person baseline — labs, biomarkers, lifestyle, recovery.', href: 'https://integratednycai.com/programs/health-optimization' },
  { code: 'PRG.02', title: 'Body Transformation', desc: 'Muscle, fat, mobility — engineered to last.', href: 'https://integratednycai.com/programs/body-transformation' },
  { code: 'PRG.03', title: 'Cognitive Optimization', desc: 'Sharper focus, deeper recall, calmer mind.', href: 'https://integratednycai.com/programs/cognitive-optimization' },
  { code: 'PRG.04', title: 'Hormone Optimization', desc: 'Restore balance — energy, libido, mood, recovery.', href: 'https://integratednycai.com/programs/hormone-optimization' },
  { code: 'PRG.05', title: 'Metabolic Optimization', desc: 'Insulin, mitochondria, longevity at the cellular level.', href: 'https://integratednycai.com/programs/metabolic-optimization' },
  { code: 'PRG.06', title: 'Performance Optimization', desc: 'Push the ceiling — strength, endurance, resilience.', href: 'https://integratednycai.com/programs/performance-optimization' },
  { code: 'PRG.07', title: 'Longevity Optimization', desc: 'Add healthy years — biological age, not just calendar age.', href: 'https://integratednycai.com/programs/longevity-optimization' },
];

export const platformUrls = {
  parent: 'https://integratednycai.com',
  bodyApp: 'https://iwmc-body-app.emergent.host',
  community: 'https://community-health-map-1.emergent.host',
  intake: ACTIVATION_FORM_URL,
  askYara: 'https://integratedwellness.jotform.com/agent/01a0a69bd2a870008ebe9f4202ca2edba3fe',
};

export const faqData = [
  {
    question: 'How do I know which panel to choose?',
    answer: "Each card explains who the panel is for. Essential Checks are a focused starting point, Follow-Ups are for people already being monitored, Baselines and Comprehensive panels go broader. Still unsure? Ask Yara, our Home Blood Kit Assistant, or contact the Integrated Wellness team."
  },
  {
    question: 'Does collecting the sample hurt?',
    answer: 'The RedDrop One uses a small lancet on the upper arm rather than a needle. Most people describe the collection as quick and virtually painless, and no training is required — step-by-step instructions are included in your kit.'
  },
  {
    question: 'Why do some panels need more than one RedDrop kit?',
    answer: 'Larger panels require more blood volume, so they ship with two or three RedDrop devices. The number of kits is shown on each panel card and is already included in the price.'
  },
  {
    question: 'What happens after I submit the activation form?',
    answer: 'The Integrated Wellness team confirms your order and bills you directly — there is no online checkout. Your kit ships to your door, you collect and return your sample in the prepaid mailer, and your results come back with personalized guidance.'
  },
  {
    question: 'Is this medical care?',
    answer: 'Home Blood Kit panels are wellness testing with personalized guidance. Where clinical follow-up is appropriate, results are reviewed by the Integrated Wellness licensed medical team, who can discuss diagnosis and treatment with you directly.'
  },
];

export const whyChooseData = [
  'Skip the clinic — no waiting rooms or time off work',
  'Collect from home on your schedule',
  'Every result feeds your Clinical Performance Index (CPI)',
  'Designed for real goals: weight loss, hormones, energy, performance',
  'Secure, private, and backed by certified labs'
];

export const features = [
  { icon: 'BadgeCheck', text: 'Certified Partner Labs' },
  { icon: 'Stethoscope', text: 'Clinician-Reviewed Results' },
  { icon: 'Shield', text: 'Secure & Private' },
  { icon: 'Truck', text: 'Prepaid Shipping Included' }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Order Your Kit',
    description: 'Choose your panel based on your goals and complete a short online form. Your kit ships directly to your door.',
    image: 'https://customer-assets.emergentagent.com/job_blood-test-kit/artifacts/x5fnmix6_s1jV5aj561SjPU9Uvrzfh.png'
  },
  {
    step: 2,
    title: 'Collect Your Sample at Home',
    description: 'Follow simple instructions to collect your sample in minutes. Pack everything into the prepaid return package.',
    image: 'https://customer-assets.emergentagent.com/job_71db82c1-71d6-4816-8e17-44dc62b144f6/artifacts/be0sl5j4_UsVtct-CH9SujJOnPzAro%20%281%29.png'
  },
  {
    step: 3,
    title: 'Get Results & Next Steps',
    description: 'Your sample is processed in our partner lab. Results feed directly into your CPI and update your optimization plan.',
    image: 'https://customer-assets.emergentagent.com/job_71db82c1-71d6-4816-8e17-44dc62b144f6/artifacts/ms4zgtaa_8OhA8LIoIvTWX4h8aiJ8C.png'
  }
];

export const contactInfo = {
  address: '331 Newman Springs Rd Building #3 Red Bank, NJ 07701',
  phone: '(201) 535-3582',
  website: 'IntegratedNYCai.com'
};

export const reviews = [
  {
    id: 1,
    name: 'Sarah M.',
    rating: 5,
    text: 'So easy to use. I was nervous about doing blood work at home but the instructions were clear and the whole process took under 5 minutes.',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Michael T.',
    rating: 5,
    text: 'Finally got my hormone levels checked without taking time off work. Results were detailed and the follow-up consultation was incredibly helpful.',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Jennifer L.',
    rating: 5,
    text: 'The convenience factor alone is worth it — but what really impressed me was how comprehensive the results report was.',
    date: '3 weeks ago'
  }
];
